




























































































































































import { Watch, Prop, Component, Vue } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { AppConstants as _app } from "@/shared/app.constants";
import { Locales } from "@/i18n/locales";

@Component({
  components: {},
})
export default class GrantsActivityLogComponent extends Vue {
  @Prop() appInfo: any;
  @Prop() GrantAmendment: any;
  defaultLocale: string = localStorage.getItem("language") || Locales.EN;

  /** Get the grant activity log */
  mounted() { }

}
